import Button from "../Button/Button";
import style from "./PriceDetails.module.scss";

const PriceDetails = ({
  cost,
  isLoading,
}: {
  cost: { amount: number; currencyCode: string | number };
  isLoading: boolean;
}) => {
  return (
    <div className={style.priceDetails}>
      <h4>Price details</h4>

      <h5>Pay at pick-up</h5>

      <ul className="flex-wrap">
        {/* <li>Car rental fee x 1 day</li> */}
        <li>
          {cost.currencyCode} {cost.amount}
        </li>
        <li>Taxes and fees</li>
        <li>included</li>
      </ul>
      <hr />
      <ol className="flex-wrap">
        <li>
          <strong>Total</strong>
        </li>
        <li>
          <strong>
            {cost.currencyCode} {cost.amount}
          </strong>
        </li>
        <li>Pay now</li>
        <li>
          {cost.currencyCode} {cost.amount}
        </li>
      </ol>

      <Button
        type="submit"
        label="Reserve"
        buttonType="isFull pill"
        disabled={isLoading}
      />
    </div>
  );
};
export default PriceDetails;
